//src/components/ProgressCardForm.jsx:-
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Box, Button, Collapse, MenuItem, Select, TextField, Typography, Autocomplete, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from "@mui/material";
import { green, orange, red, grey } from "@mui/material/colors";
import env from "react-dotenv";
import RawMaterialForm from './RawMaterialForm'; // Import the new component
import ChemicalForm from './ChemicalForm'; // Import the new component
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete'; // Import the Delete icon
import { useSelector } from 'react-redux';

const ProgressCardForm = ({ progressFormOpen, setProgressFormOpen, cardDetails, departmentDetails, steps, operatorFullName, bomDetails, bomChemicals, setDrawerOpen, currentStepStatus, setExpandedDrawer }) => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [currentStep, setCurrentStep] = useState(null);
  const [machineNames, setMachineNames] = useState([]); // To store machine list as comma-separated values
  const [productDetailsList, setProductDetailsList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const productOptions = bomDetails.map((bom) => bom.part_name);
  const [selectedRawMaterial, setSelectedRawMaterial] = useState(null);
  const [isRawMaterialFormOpen, setIsRawMaterialFormOpen] = useState(false);
  const [openingQuantity, setOpeningQuantity] = useState('');
  const [proceedQuantity, setProceedQuantity] = useState('');
  const [acceptedQuantity, setAcceptedQuantity] = useState('');
  const [rejectedQuantity, setRejectedQuantity] = useState('');
  const [quantities, setQuantities] = useState([]); // State to hold quantities of selected raw materials
  const [rawMaterialQuantities, setRawMaterialQuantities] = useState([]);
  const [tempRawMaterialQuantities, setTempRawMaterialQuantities] = useState([]);
  const [chemicalOptions, setChemicalOptions] = useState([]);
  // const [selectedChemical, setSelectedChemical] = useState([]);
  const [selectedChemical, setSelectedChemical] = useState(null); // Change this to null if you want to store a single selected chemical
  const [isChemicalFormOpen, setIsChemicalFormOpen] = useState(false);
  const [tempChemicalQuantities, setTempChemicalQuantities] = useState([]);
  const [nextStep, setNextStep] = useState('');
  const [savedRawMaterialQuantities, setSavedRawMaterialQuantities] = useState([]);
  const [savedChemicalQuantities, setSavedChemicalQuantities] = useState([]);
  const [rawMaterialReference, setRawMaterialReference] = useState([]);
  const user = useSelector((state) => state.user);

  const role = user.role;
  const userName = user.userName;
  const userId = user.id;
  // console.log("User role :", role);
  // console.log("User name :", userName);
  // console.log("User Id :", userId);
  // console.log("current steps: ", currentStepStatus);
  // console.log("current step id: ", currentStepStatus.step_id);
  // console.log("current step order: ", currentStepStatus.step_order);

  // console.log("Current step id : ", cardDetails.current_step_id);
  // console.log("Current step order : ", cardDetails.step_order);
  // console.log("Operator ID : ", cardDetails.current_operator_id);

  const handleRawMaterialSelect = (rawMaterial) => {
    // console.log("Selected Raw Material:", rawMaterial); // Log the raw material
    setSelectedRawMaterial(rawMaterial); // Ensure this is the correct value
    setIsRawMaterialFormOpen(true);
    setExpandedDrawer(true);
  };

const handleRawMaterialFormSave = (data) => {
  setTempRawMaterialQuantities((prev) => {
    const index = prev.findIndex(item => item.RM_id === data.RM_id);
    if (index !== -1) {
      // Update existing entry
      const updatedQuantities = [...prev];
      updatedQuantities[index] = data; // Update the entry
      return updatedQuantities;
    } else {
      // Add new entry if it doesn't exist
      return [...prev, data];
    }
  });

  setIsRawMaterialFormOpen(false);
  setExpandedDrawer(false);
};

const handleRemoveRawMaterial = (itemToRemove) => {
  // Remove from tempRawMaterialQuantities
  setTempRawMaterialQuantities(prev => {
    const updated = prev.filter(item => item.RM_id !== itemToRemove.RM_id);
    
    // Also remove from selectedProducts if it exists
    setSelectedProducts(prevSelected => prevSelected.filter(item => item.RM_id !== itemToRemove.RM_id));
    
    return updated;
  });
};

  const handleRawMaterialFormCancel = () => {
    setIsRawMaterialFormOpen(false);
    setExpandedDrawer(false);
  };

  const handleChemicalSelect = (chemical) => {
  // console.log("Selected Chemical:", chemical); // Check if this is called
  setSelectedChemical(chemical);
  setIsChemicalFormOpen(true);
  setExpandedDrawer(true);

  // Update formData with the selected chemical
  setFormData((prev) => ({
      ...prev,
      selectedChemical: chemical.RM_name, // Store the chemical name or any other relevant data
  }));
};

  const handleChemicalFormSave = (data) => {
    setTempChemicalQuantities((prev) => {
        const index = prev.findIndex(item => item.RM_id === data.RM_id);
        if (index !== -1) {
            // Update existing entry
            const updatedQuantities = [...prev];
            updatedQuantities[index] = {
                ...data,
                chemical_name: data.RM_name // Ensure chemical_name is set correctly
            }; 
            return updatedQuantities;
        } else {
            // Add new entry if it doesn't exist
            return [...prev, {
                ...data,
                chemical_name: data.RM_name // Ensure chemical_name is set correctly
            }];
        }
    });
    setIsChemicalFormOpen(false);
    setExpandedDrawer(false);
};

const handleRemoveChemical = (itemToRemove) => {
  // Remove from tempChemicalQuantities
  setTempChemicalQuantities(prev => {
    const updated = prev.filter(item => item.RM_id !== itemToRemove.RM_id);
    
    // Also remove from selectedChemical if it exists
    if (selectedChemical && selectedChemical.RM_id === itemToRemove.RM_id) {
      setSelectedChemical(null); // Reset selectedChemical if it was the one being removed
    }
    
    return updated;
  });
};

  const handleChemicalFormCancel = () => {
    setIsChemicalFormOpen(false);
    setExpandedDrawer(false);
  };

  // In the chemical deselection handler
const handleChemicalChange = (event, newValue) => {
  setSelectedChemical(newValue);
  // Remove the chemical from the display table if deselected
  if (newValue.length === 0) {
    setTempChemicalQuantities(prev => prev.filter(item => item.RM_id !== selectedChemical.RM_id));
  }
};

  // Fetch chemical options based on product_id and current_step_name
  useEffect(() => {
    const fetchChemicalOptions = async () => {
        if (!cardDetails.product_id || !currentStepStatus.step_name) {
            console.error("No product_id or current_step_name found.");
            return;
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productwisemachine/rm-names/${cardDetails.product_id}`, {
                params: {
                    step_name: currentStepStatus.step_name // Pass the current step name as a query parameter
                }
            });

            // Log the response to check the structure
            // console.log("Fetched Chemical Options:", response.data);

            // Access the first array of the response
            const chemicals = response.data[0]; // Get the first array

            // Filter chemicals based on bomChemicals
            const filteredChemicals = chemicals.filter(item => 
                bomChemicals.some(chemical => chemical.chemical_id === item.RM_id)
            );

            // Create a map to store unique chemical names with their corresponding chemical_id
            const uniqueChemicalNames = {};

            filteredChemicals.forEach(item => {
                if (!uniqueChemicalNames[item.RM_name]) {
                    uniqueChemicalNames[item.RM_name] = item.RM_id; // Store RM_id for the unique RM_name
                }
            });

            // Convert the map back to an array of objects
            const uniqueChemicalArray = Object.keys(uniqueChemicalNames).map(name => ({
                RM_name: name,
                RM_id: uniqueChemicalNames[name],
            }));

            setChemicalOptions(uniqueChemicalArray); // Set the list to an array of unique chemicals
        } catch (error) {
            console.error("Error fetching chemical options:", error);
        }
    };

    fetchChemicalOptions(); // Fetch chemical options on component mount
}, [cardDetails.product_id, currentStepStatus.step_name, bomChemicals]);

  const [formData, setFormData] = useState({
    machineNames: "",
    productDetails: [], // Initialize as an array
    startDate: "",
    finishDate: "",
    observed: "",
    observedValue: "",
    // operatorName: operatorFullName || "", // Set operatorName
    // operatorName: operatorFullName && operatorFullName.trim() !== "" ? operatorFullName : userName, // Set operatorName
    operatorName: userName, // Set operatorName
    inspectorName: "",
    quantity: "",
    remarks: "",
    plan_id: cardDetails.plan_id, // Add plan_id
    job_card_id: cardDetails.job_card_id, // Add job_card_id
    step_id: currentStepStatus.step_id, // Corrected
    step_name: currentStepStatus.step_name,
    dept_name: currentStepStatus.dept_name,
    // operator_id: cardDetails.current_operator_id,
    // operator_id: (typeof currentStepStatus.operator_id === 'string' && currentStepStatus.operator_id.trim() !== "") 
    //     ? currentStepStatus.operator_id 
    //     : userId, // Set operator_id
    operator_id: userId, // Set operator_id
    selectedChemical: "", // Add this line to store the selected chemical
  });

  useEffect(() => {
    // Check if currentStepStatus is available and set it as the current step
    if (currentStepStatus) {
        setCurrentStep(currentStepStatus);
    } else if (departmentDetails?.steps && cardDetails?.steps) {
        // Fallback to finding the last pending step if currentStepStatus is not available
        const lastPendingStep = cardDetails.steps.find((s) => s.step_status === "pending");
        setCurrentStep(lastPendingStep);
    }
}, [departmentDetails, cardDetails, currentStepStatus]);

  useEffect(() => {
    const fetchProgressCardData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/progress-card/view`, {
                params: {
                    job_card_id: cardDetails.job_card_id,
                    plan_id: cardDetails.plan_id,
                    step_id: currentStepStatus.step_id,
                },
            });
            const progressCardData = response.data; // Now this is a flat array of objects

            // Log the entire progressCardData to inspect its structure
            // console.log("Fetched Progress Card Data:", progressCardData);

            // Assuming there's only one record, you can access it directly
            if (progressCardData.length > 0) {
                const data = progressCardData[0]; // Get the first object

                // console.log("Fetched Progress Card Data:", data);
                
                // Set machine names from the fetched progress card data
                  if (data.machine_name) {
                    setMachineNames([data.machine_name]); // Wrap in an array
                  } else {
                    setMachineNames([]);
                  }

                  // Set the selected machine in formData
                  setFormData((prev) => ({
                    ...prev,
                    machineNames: data.machine_name || "", // Ensure this matches one of the options
                  }));

                // Fetch raw material quantities
                const rawMaterialResponse = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/raw-material-quantities`, {
                  params: {
                      progress_card_id: data.id,
                  },
              });
              setRawMaterialQuantities(rawMaterialResponse.data[0]); // Access the first element
              setSavedRawMaterialQuantities(rawMaterialResponse.data[0]);

                // Fetch chemical quantities
                const chemicalResponse = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/chemical-quantities`, {
                    params: {
                        progress_card_id: data.id,
                    },
                });
                setTempChemicalQuantities(chemicalResponse.data);
                setSavedChemicalQuantities(chemicalResponse.data);

                // Parse raw_material from string to array
                // const parsedRawMaterial = JSON.parse(data.raw_material);
                // ✅ Parse raw_material and store in state
                const parsedRawMaterial = JSON.parse(data.raw_material || "[]");
                setRawMaterialReference(parsedRawMaterial); // Contains RM_id and RM_name

                const newData = {
                    machineNames: data.machine_name,
                    productDetails: parsedRawMaterial,
                    startDate: data.start_date.split("T")[0],
                    finishDate: data.finish_date.split("T")[0],
                    observed: data.observed,
                    observedValue: data.observed_value,
                    quantity: data.quantity,
                    operatorName: data.operator_name,
                    inspectorName: data.inspector_name,
                    remarks: data.remarks,
                    plan_id: data.plan_id,
                    job_card_id: data.job_card_id,
                    step_id: data.step_id,
                    step_name: data.step_name,
                    dept_name: data.dept_name,
                    operator_id: data.operator_id,
                    selectedChemical: data.selected_chemical,
                };
                setFormData(newData);
            } } catch (error) {
            console.error("Error fetching progress card data:", error);
        }
    };

    fetchProgressCardData();
}, [cardDetails.job_card_id, cardDetails.plan_id, currentStepStatus.step_id]);
  
  const fetchMachineList = async () => {
    if (!currentStepStatus.step_id) {
      console.error("No current step id found.");
      return;
    }
  
    // Check if the current step name is "Raw Material Issue"
    if (currentStepStatus.step_name === "Raw Material Issue") {
      setMachineNames(["Manual"]); // Set machine names to "Manual"
      return; // Exit the function early
    }
  
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PJCBACKEND_URL}/api/productwisemachine/step/${currentStepStatus.step_id}/machines`
      );
  
      if (response.data && Array.isArray(response.data)) {
        const machines = response.data[0].map((machine) => machine.machine);
        setMachineNames(machines);
      } else {
        setMachineNames([]);
      }
    } catch (error) {
      console.error("Error fetching machine list:", error);
    }
  };
  
  useEffect(() => {
    fetchMachineList();
  }, [currentStepStatus.step_id]);
  
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

const handleProductChange = (event, newValue) => {
  // Update selected products
  setSelectedProducts(newValue);
  handleChange("productDetails", newValue); // Update formData.productDetails

  // Check for deselection
  const deselectedRawMaterials = selectedProducts.filter(item => !newValue.includes(item));
  deselectedRawMaterials.forEach(deselected => {
    // Remove the deselected raw material from the display table
    setTempRawMaterialQuantities(prev => prev.filter(item => item.RM_id !== deselected.RM_id));
  });

  // Open form for the last selected raw material if any
  if (newValue.length > 0) {
    const lastSelectedRawMaterial = newValue[newValue.length - 1];
    handleRawMaterialSelect(lastSelectedRawMaterial); // Open form for the last selected raw material
  }
};

const handleSave = async () => {
  try {
      const response = await axios.post(
          `${process.env.REACT_APP_PJCBACKEND_URL}/api/progress-card/save`,
          formData
      );

      // console.log("API Response:", response.data); // Log the entire response

      if (response.status === 200 || response.status === 201) {
          const progressCardId = response.data.id; // Get the ID of the newly created or updated progress card
          // console.log("Progress Card ID:", progressCardId); // Log the progress card ID

          // Check if progressCardId is undefined
          if (!progressCardId) {
            console.error("Progress Card ID is undefined");
            return;
        }

          // Save raw material quantities
          await Promise.all(tempRawMaterialQuantities.map(async (item) => {
              await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/raw-material-quantities/save`, {
                  progress_card_id: progressCardId, // Use the retrieved ID
                  RM_name: item.RM_name,
                  openingQuantity: item.openingQuantity,
                  proceedQuantity: item.proceedQuantity,
                  acceptedQuantity: item.acceptedQuantity,
                  rejectedQuantity: item.rejectedQuantity,
              });
          }));

          // Save chemical quantities
          await Promise.all(tempChemicalQuantities.map(async (item) => {
            await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/chemical-quantities/save`, {
                progress_card_id: progressCardId, // Use the retrieved ID
                chemical_name: item.chemical_name, // Use the chemical name
                openingQuantity: item.openingQuantity,
                proceedQuantity: item.proceedQuantity,
            });
        }));

          // Clear the temporary quantities
          setTempRawMaterialQuantities([]);
          setTempChemicalQuantities([]);

          alert(response.data.message);
          window.location.href = "/process-steps";
      }
  } catch (error) {
      console.error("Error saving progress card:", error);
      // alert("Failed to save progress card. Please try again.");
  }
};

const handleSaveMarkASDone = async () => {
  try {
      const response = await axios.post(
          `${process.env.REACT_APP_PJCBACKEND_URL}/api/progress-card/save`,
          formData
      );

      // console.log("API Response:", response.data); // Log the entire response

      if (response.status === 200 || response.status === 201) {
          const progressCardId = response.data.id; // Get the ID of the newly created or updated progress card
          // console.log("Progress Card ID:", progressCardId); // Log the progress card ID

          // Check if progressCardId is undefined
          if (!progressCardId) {
            console.error("Progress Card ID is undefined");
            return;
        }

          // Save raw material quantities
          await Promise.all(tempRawMaterialQuantities.map(async (item) => {
              await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/raw-material-quantities/save`, {
                  progress_card_id: progressCardId, // Use the retrieved ID
                  RM_name: item.RM_name,
                  openingQuantity: item.openingQuantity,
                  proceedQuantity: item.proceedQuantity,
                  acceptedQuantity: item.acceptedQuantity,
                  rejectedQuantity: item.rejectedQuantity,
              });
          }));

          // Save chemical quantities
          await Promise.all(tempChemicalQuantities.map(async (item) => {
            await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/chemical-quantities/save`, {
                progress_card_id: progressCardId, // Use the retrieved ID
                chemical_name: item.chemical_name, // Use the chemical name
                openingQuantity: item.openingQuantity,
                proceedQuantity: item.proceedQuantity,
            });
        }));

          // Clear the temporary quantities
          setTempRawMaterialQuantities([]);
          setTempChemicalQuantities([]);

          // alert(response.data.message);
          // window.location.href = "/process-steps";

          // Return the whole response for further use
          return response;
      } else {
          console.error("Error saving progress card:", response);
          return null;
      }
  } catch (error) {
      console.error("Error saving progress card:", error);
      // alert("Failed to save progress card. Please try again.");
      return null;
  }
};

// const markAsDone = async () => {
//   try {
//     await handleSaveMarkASDone(); // Save the progress card data first

//     // console.log("Raw Material Quantities:", tempRawMaterialQuantities);
//     // console.log("Chemical Quantities:", tempChemicalQuantities);
//     // console.log("Card Details:", cardDetails);

//     // Save raw material quantities
//     await Promise.all(tempRawMaterialQuantities.map(async (item) => {
//       const rawMaterialFormData = {
//         RM_id: item.RM_id,
//         RM_name: item.RM_name,
//         product_id: cardDetails.product_id,
//         openingQuantity: item.openingQuantity,
//         proceedQuantity: item.proceedQuantity,
//         acceptedQuantity: item.acceptedQuantity,
//         rejectedQuantity: item.rejectedQuantity,
//         process_name: cardDetails.current_step_name,
//         next_step: nextStep,
//         step_order: currentStep.step_order,
//         cardDetails,
//         departmentDetails,
//         steps
//       };
//       console.log("Saving raw material:", rawMaterialFormData);
//       try {
//         await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productionlocinventory/save-quantities-new`, rawMaterialFormData);
//       } catch (error) {
//         console.error("Error saving raw material:", error.response ? error.response.data : error.message);
//       }
//     }));

//     // Save chemical quantities
//     await Promise.all(tempChemicalQuantities.map(async (item) => {
//       const chemicalFormData = {
//         RM_id: item.RM_id,
//         RM_name: item.RM_name,
//         openingQuantity: item.openingQuantity,
//         quantity: item.proceedQuantity,
//       };
//       console.log("Updating chemical quantity:", chemicalFormData);
//       try {
//         await axios.put(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productionlocinventory/update-chemical-quantity/${item.RM_id}`, chemicalFormData);
//       } catch (error) {
//         console.error("Error updating chemical quantity:", error.response ? error.response.data : error.message);
//       }
//     }));

//     // Prepare the data for marking as done
//     const requestData = {
//       job_card_id: cardDetails.job_card_id,
//       step_id: currentStep.step_id,
//       step_name: currentStep.step_name,
//       dept_name: currentStep.dept_name,
//       operator_id: cardDetails.operator_id, // Ensure this is set correctly
//     };

//     // console.log("Request Data for Mark As Done:", requestData); // Log the request data

//     // Now mark the step as done
//     const response = await axios.post(
//       `${process.env.REACT_APP_PJCBACKEND_URL}/api/job-cards/mark-as-done-new`,
//       requestData
//     );

//     alert(response.data.message);
//     navigate(`/view-job-card/${cardDetails?.plan_id}`);
//   } catch (err) {
//     console.error("Error marking as done:", err.response ? err.response.data : err.message);
//     alert("Error marking step as done.");
//   }
// };

const markAsDone = async () => {
  try {
    // First, save the form data
    const response = await handleSaveMarkASDone(); // Save form first

    // Check if the form was saved successfully
    if (!response || (response.status !== 200 && response.status !== 201)) {
      console.error("Failed to save progress card before marking as done.");
      return; // Exit if saving failed
    }

    const rawMaterialsToSend = tempRawMaterialQuantities.length > 0 ? tempRawMaterialQuantities : savedRawMaterialQuantities;
    const chemicalsToSend = tempChemicalQuantities.length > 0 ? tempChemicalQuantities : savedChemicalQuantities;

    // ✅ Send raw material data
    await Promise.all(rawMaterialsToSend.map(async (item) => {
      // Find RM_id using RM_name in reference
        const matchedRM = rawMaterialReference.find(rm => rm.RM_name === item.RM_name);
        // Use matchedRM.RM_id if found else fallback to item.RM_id if present
        const RM_id = matchedRM?.RM_id || item.RM_id || null;

      if (!RM_id) {
        console.warn(`Missing RM_id for RM_name: ${item.RM_name}`);
        return;
      }

      const rawMaterialFormData = {
        RM_id,
        RM_name: item.RM_name,
        product_id: cardDetails.product_id,
        openingQuantity: item.openingQuantity,
        proceedQuantity: item.proceedQuantity,
        acceptedQuantity: item.acceptedQuantity,
        rejectedQuantity: item.rejectedQuantity,
        process_name: currentStepStatus.step_name,
        next_step: nextStep,
        step_order: currentStepStatus.step_order,
        cardDetails,
        departmentDetails,
        steps
      };
      try {
        await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productionlocinventory/save-quantities-new`, rawMaterialFormData);
      } catch (error) {
        console.error("Error saving raw material:", error.response?.data || error.message);
      }
    }));

    // ✅ Send chemical data
    await Promise.all(chemicalsToSend.map(async (item) => {
      const chemicalFormData = {
        RM_id: item.RM_id,
        RM_name: item.RM_name,
        openingQuantity: item.openingQuantity,
        quantity: item.proceedQuantity,
      };
      try {
        await axios.put(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productionlocinventory/update-chemical-quantity/${item.RM_id}`, chemicalFormData);
      } catch (error) {
        console.error("Error updating chemical quantity:", error.response?.data || error.message);
      }
    }));

    // ✅ Mark step as done
    const requestData = {
      job_card_id: cardDetails.job_card_id,
      step_id: currentStepStatus.step_id,
      step_name: currentStepStatus.step_name,
      dept_name: currentStepStatus.dept_name,
      operator_id: cardDetails.current_operator_id,
      product_id: cardDetails.product_id
    };
    const markAsDoneResponse  = await axios.post(
      `${process.env.REACT_APP_PJCBACKEND_URL}/api/job-cards/mark-as-done-new`,
      requestData
    );

    alert(markAsDoneResponse .data.message);
    navigate(`/view-job-card/${cardDetails?.plan_id}`);
  } catch (err) {
    console.error("Error marking as done:", err.response?.data || err.message);
    alert("Error marking step as done.");
  }
};

  // Fetch raw materials based on product_id and current_step_name
  const fetchProductOptions = async () => {
    if (!cardDetails.product_id || !currentStepStatus.step_name) {
      console.error("No product_id or current_step_name found.");
      return;
    }
  
    try {
      const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productwisemachine/rm-names/${cardDetails.product_id}`, {
        params: {
          step_name: currentStepStatus.step_name // Pass the current step name as a query parameter
        }
      });
  
      if (response.data && Array.isArray(response.data)) {
        const rawMaterials = response.data[0].map((rawMaterial) => ({
          RM_id: rawMaterial.RM_id,
          RM_name: rawMaterial.RM_name,
        }));
  
        // Create a map to store unique RM_names with their corresponding RM_id
        const uniqueRMNames = {};
  
        rawMaterials.forEach(item => {
          if (!uniqueRMNames[item.RM_name]) {
            uniqueRMNames[item.RM_name] = item.RM_id; // Store RM_id for the unique RM_name
          }
        });
  
        // Convert the map back to an array of objects
        const uniqueRMArray = Object.keys(uniqueRMNames).map(name => ({
          RM_name: name,
          RM_id: uniqueRMNames[name],
        }));
  
        // Filter out chemicals from the raw materials
        const filteredRawMaterials = uniqueRMArray.filter(rawMaterial => 
          !bomChemicals.some(chemical => chemical.chemical_id === rawMaterial.RM_id)
        );
  
        setProductDetailsList(filteredRawMaterials); // Set the list to an array of unique raw materials
      } else {
        setProductDetailsList([]);
      }
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    fetchProductOptions(); // Fetch product options on component mount
  }, [cardDetails.product_id, currentStepStatus.step_name, bomChemicals]); // Dependencies on product_id, current_step_name, and bomChemicals

  return (
    
    <Box sx={{ display: 'flex', gap: 2 }}>
    <Box sx={{ flex: 1 }}>
      {/* Progress Form Toggle */}
<Button
  fullWidth
  sx={{
    mt: 1,
    borderBottom: `2px solid ${grey[300]}`,
    paddingBottom: 1,
    textAlign: "left",
    justifyContent: "flex-start",
  }}
  onClick={() => setProgressFormOpen(!progressFormOpen)}
>
{progressFormOpen ? "▲" : "▼"} Progress Card
</Button>
      <Collapse in={progressFormOpen}>
        <Box sx={{ mt: 1, p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
          {/* <Typography variant="body1" fontWeight="bold" sx={{ textAlign: "center", mb: 2 }}>
            Progress Card: {cardDetails.current_step_name || "Not Available"}
          </Typography> */}
          <Typography variant="body1" fontWeight="bold" sx={{ textAlign: "center", mb: 2 }}>
            Progress Card: {currentStepStatus?.step_status === "completed" ? formData.step_name : currentStepStatus?.step_name || "Not Available"}
          </Typography>

{/* Container for Select Machine and Autocomplete fields */}
<Box sx={{ display: "flex", gap: 2, marginBottom: 2 }}>
  {/* Select Machine Dropdown */}
  <TextField
    select
    label="Select Machine"
    fullWidth
    value={formData.machineNames} // Ensure this is a string that matches one of the options
    onChange={(e) => handleChange("machineNames", e.target.value)}
    disabled={currentStepStatus?.step_status !== "pending"} // Disable if not pending
    sx={{
      flex: 1, // Takes half the available space
      "& .MuiInputBase-root": { minHeight: 36 },
      "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
    }}
  >
    {machineNames.length === 0 ? (
      <MenuItem disabled>No machines available</MenuItem>
    ) : (
      machineNames.map((machine, index) => (
        <MenuItem key={index} value={machine}>
          {machine}
        </MenuItem>
      ))
    )}
  </TextField>

<Autocomplete
  multiple
  options={productDetailsList}
  getOptionLabel={(option) => option.RM_name} // Display the RM_name in the dropdown
  value={selectedProducts} // Ensure this is an array of objects
  onChange={handleProductChange}
  disabled={currentStepStatus?.step_status !== "pending"}
  sx={{
    flex: 1,
    "& .MuiOutlinedInput-root": { minHeight: 36 },
  }}
  renderInput={(params) => (
    <TextField {...params} label="Select Raw Materials" variant="outlined" />
  )}
/>

</Box>

{/* Table to Display All Quantities of Selected Raw Materials */}
<Box sx={{ display: "flex", gap: 2, marginBottom: 2 }}>
    <TableContainer component={Paper} sx={{ maxHeight: 200, border: '1px solid #ccc' }}>
        <Table size="small" sx={{ border: '1px solid #ccc' }}>
            <TableHead>
                <TableRow>
                    <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>Raw Material</TableCell>
                    <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>Opening Quantity</TableCell>
                    <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>Processed Quantity</TableCell>
                    <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>Accepted Quantity</TableCell>
                    <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>Rejected Quantity</TableCell>
                    <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>Action</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {/* Render both temp and fetched raw material quantities */}
                {[...rawMaterialQuantities, ...tempRawMaterialQuantities].map((item, index) => (
                    <TableRow key={index} sx={{ height: '30px' }}>
                        <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>{item.RM_name}</TableCell>
                        <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>{item.openingQuantity}</TableCell>
                        <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>{item.proceedQuantity}</TableCell>
                        <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>{item.acceptedQuantity}</TableCell>
                        <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>{item.rejectedQuantity}</TableCell>
                        <TableCell padding="none" sx={{ textAlign: 'center', borderRight: '1px solid #ccc' }}>
                        <IconButton disabled={currentStepStatus?.step_status !== "pending"} onClick={() => handleRawMaterialSelect(item)}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton disabled={currentStepStatus?.step_status !== "pending"} onClick={() => handleRemoveRawMaterial(item)}>
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
</Box>

<Box sx={{ marginBottom: 2 }}>
  
<Autocomplete
  options={chemicalOptions} // Use the fetched chemical options
  getOptionLabel={(option) => option.RM_name} // Display the chemical name
  value={selectedChemical || null} // Set the selected chemical object directly
  disabled={currentStepStatus?.step_status !== "pending"} // Disable if not pending
  onChange={(event, newValue) => {
    if (newValue) {
      handleChemicalSelect(newValue); // Open the chemical form
    } else {
      // Handle deselection
      handleRemoveChemical(selectedChemical); // Remove from display table
    }
  }}
  renderInput={(params) => (
    <TextField {...params} label="Select Chemicals" variant="outlined" />
  )}
/>

</Box>

{/* Table to Display All Quantities of Selected Raw Materials */}
<Box sx={{ display: "flex", gap: 2, marginBottom: 2 }}>
  <TableContainer component={Paper} sx={{ maxHeight: 200, border: '1px solid #ccc' }}>
    <Table size="small" sx={{ border: '1px solid #ccc' }}>
      <TableHead>
        <TableRow>
          <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>Chemical</TableCell>
          <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>Opening Quantity</TableCell>
          <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>Used Quantity</TableCell>
          <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>Action</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {/* Render chemicals */}
        {tempChemicalQuantities.map((item, index) => (
          <TableRow key={index} sx={{ height: '30px' }}>
            <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>{item.chemical_name}</TableCell>
            <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>{item.openingQuantity}</TableCell>
            <TableCell padding="none" sx={{ fontSize: '0.8rem', textAlign: 'center', borderRight: '1px solid #ccc' }}>{item.proceedQuantity}</TableCell>
            <TableCell padding="none" sx={{ textAlign: 'center', borderRight: '1px solid #ccc' }}>
              <IconButton disabled={currentStepStatus?.step_status !== "pending"} onClick={() => handleChemicalSelect(item)}>
                <EditIcon fontSize="small" />
              </IconButton>
              <IconButton disabled={currentStepStatus?.step_status !== "pending"} onClick={() => handleRemoveChemical(item)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
</Box>

          <TextField label="Start Date" type="date" InputLabelProps={{shrink: true,}} value={formData.startDate} onChange={(e) => handleChange("startDate", e.target.value)}
          disabled={currentStepStatus?.step_status !== "pending"} // Disable if not pending
          sx={{
            marginBottom: 2,
            marginRight: 1,
            width: "48%",
            "& .MuiInputBase-root": { minHeight: 36 },
            "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
            }}
             />
          <TextField label="Finish Date" type="date" InputLabelProps={{shrink: true,}} value={formData.finishDate} onChange={(e) => handleChange("finishDate", e.target.value)}
          disabled={currentStepStatus?.step_status !== "pending"} // Disable if not pending
          sx={{
            marginBottom: 2,
            width: "48%",
            "& .MuiInputBase-root": { minHeight: 36 },
            "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
            }}
           />

          <TextField fullWidth label="Observed" value={formData.observed} onChange={(e) => handleChange("observed", e.target.value)} 
          disabled={currentStepStatus?.step_status !== "pending"} // Disable if not pending
          sx={{
            marginBottom: 2,
            marginRight: 1,
            width: "48%",
            "& .MuiInputBase-root": { minHeight: 36 },
            "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
            }}
             />
          <TextField fullWidth label="Observed Value" value={formData.observedValue} onChange={(e) => handleChange("observedValue", e.target.value)} 
          disabled={currentStepStatus?.step_status !== "pending"} // Disable if not pending
          sx={{
            marginBottom: 2,
            width: "48%",
            "& .MuiInputBase-root": { minHeight: 36 },
            "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
            }}
             />

          <TextField fullWidth label="Operator Name" value={formData.operatorName} onChange={(e) => handleChange("operatorName", e.target.value)} 
          disabled={true} // Disable the field
          // disabled={currentStepStatus?.step_status !== "pending"} // Disable if not pending
          sx={{
            marginBottom: 2,
            marginRight: 1,
            width: "48%",
            "& .MuiInputBase-root": { minHeight: 36 },
            "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
            }}
             />
          <TextField fullWidth label="Inspector Name" value={formData.inspectorName} onChange={(e) => handleChange("inspectorName", e.target.value)} 
          disabled={currentStepStatus?.step_status !== "pending"} // Disable if not pending
          sx={{
            marginBottom: 2,
            width: "48%",
            "& .MuiInputBase-root": { minHeight: 36 },
            "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
            }}
             />

          {/* <TextField fullWidth label="Quantity" type="number" value={formData.quantity} onChange={(e) => handleChange("quantity", e.target.value)} 
          disabled={currentStepStatus?.step_status !== "pending"} // Disable if not pending
          sx={{
            marginBottom: 2,
            marginRight: 1,
            width: "48%",
            "& .MuiInputBase-root": { minHeight: 36 },
            "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
            }}
             /> */}
          <TextField fullWidth label="Remarks" multiline rows={2} value={formData.remarks} onChange={(e) => handleChange("remarks", e.target.value)} 
          disabled={currentStepStatus?.step_status !== "pending"} // Disable if not pending
          sx={{
            marginBottom: 2,
            // width: "48%",
            "& .MuiInputBase-root": { minHeight: 36 },
            "& .MuiInputBase-input": { padding: "3px 6px", fontSize: "0.75rem" },
            }}
             />
             
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            {currentStepStatus?.step_status === "completed" ? (
              <Button variant="outlined" color="error" onClick={() => setDrawerOpen(false)} size="small"
                sx={{ fontSize: "0.65rem", padding: "3px 6px" }} >Cancel</Button>
            ) : (
              <>
                <Button variant="contained" color="success" onClick={handleSave} size="small"
                  sx={{ fontSize: "0.65rem", padding: "3px 6px" }} >Save</Button>
                <Button
                  variant="outlined" // Change to outlined variant
                  size="small"
                  onClick={() => markAsDone(currentStepStatus)}
                  disabled={!currentStepStatus || currentStepStatus.step_status === "completed" || isSaving}
                  sx={{
                    fontSize: "0.65rem",
                    padding: "3px 6px",
                    borderColor: "green", // Set the border color to green
                    color: "green", // Set the text color to green
                    "&:hover": {
                      backgroundColor: "rgba(0, 128, 0, 0.1)", // Optional: Light green background on hover
                      borderColor: "green", // Keep the border color green on hover
                    },
                  }}
                >
                  Mark as Done
                </Button>
                <Button variant="outlined" color="error" onClick={() => setDrawerOpen(false)} size="small"
                  sx={{ fontSize: "0.65rem", padding: "3px 6px" }} >Cancel</Button>
              </>
              )}
          </Box>
        </Box>
      </Collapse>
      </Box>
      {/* Render Raw Material Form if open */}
      {isRawMaterialFormOpen && (
        <RawMaterialForm
          selectedRawMaterial={selectedRawMaterial}
          RM_id={selectedRawMaterial?.RM_id} // Pass the RM_id directly
          RM_name={selectedRawMaterial?.RM_name} // Pass the product ID if available
          openingQuantity={selectedRawMaterial?.openingQuantity} // Pass the opening quantity
          proceedQuantity={selectedRawMaterial?.proceedQuantity} // Pass the processed quantity
          acceptedQuantity={selectedRawMaterial?.acceptedQuantity} // Pass the accepted quantity
          rejectedQuantity={selectedRawMaterial?.rejectedQuantity} // Pass the rejected quantity
          plan_id={cardDetails.plan_id} // Pass plan_id
          job_card_id={cardDetails.job_card_id} // Pass job_card_id
          product_id={cardDetails.product_id} // Pass product_id
          onSave={handleRawMaterialFormSave}
          onCancel={handleRawMaterialFormCancel}
          cardDetails={cardDetails}
          departmentDetails={departmentDetails}
          steps={steps}
          bomDetails={bomDetails}
          currentStepStatus={currentStepStatus}
        />
      )}

      {/* Render Chemical Form if open */}
      {isChemicalFormOpen && (
          <ChemicalForm
            selectedChemical={selectedChemical}
            RM_id={selectedChemical?.RM_id} // Pass the RM_id directly
            RM_name={selectedChemical?.RM_name} // Pass the product ID if available
            plan_id={cardDetails.plan_id} // Pass plan_id
            job_card_id={cardDetails.job_card_id} // Pass job_card_id
            openingQuantity={selectedChemical?.openingQuantity}
            proceedQuantity={selectedChemical?.proceedQuantity}
            onSave={handleChemicalFormSave}
            onCancel={handleChemicalFormCancel}
            cardDetails={cardDetails}
            departmentDetails={departmentDetails}
            steps={steps}
            bomDetails={bomDetails}
            bomChemicals={bomChemicals}
            currentStepStatus={currentStepStatus}
          />
      )}

      </Box>
  );
};

export default ProgressCardForm;
